<ng-container *ngrxLet="viewModel$; let value">
  <div id="side-nav-bar">

    <mat-icon id="logo" [svgIcon]="getLogoName()"/>

    <div id="nav-button-container">
      @for (processedButton of navigationButtons; let first = $first; track processedButton.route) {

        @if (isTabVisible(value.details, processedButton.route, value.selectedAccount)) {

          @if (processedButton.route !== mainRoutes.INSIGHTS) {
            <div class="nav-button"
                 [id]="processedButton.route + '-nav-button'"
                 (click)="navigate(processedButton.route)"
                 [ngClass]="{ 'text-neutral-10': processedButton.route === activeRoute,
                              'mt-4': !first }">
              <div class="icon-container"
                   [ngClass]="{ 'bg-green-90': processedButton.route === activeRoute }">
                <!--                TODO: revert back to just 1 if/else block after removing BETA Badge -->
                @if (processedButton.route === mainRoutes.AI_INSIGHTS) {
                  <mat-icon [svgIcon]="processedButton.svgName" [matBadge]="'LABS' | translate"/>
                } @else {
                  <mat-icon [svgIcon]="processedButton.route === activeRoute ? processedButton.svgName + '_filled' :
                                     processedButton.svgName"/>
                }

              </div>
              <span class="text-center">{{
                  ('PAGE.' + processedButton.route.toUpperCase()) | translate
                }}</span>
            </div>

          } @else {
            <div class="nav-button mt-4"
                 [ngClass]="{ 'text-neutral-10': processedButton.route === activeRoute }"
                 (mouseenter)="openInsightsMenu()"
                 (mouseleave)="closeInsightsMenu()">

              <div [matMenuTriggerFor]="insightsMenu"
                   [matMenuTriggerData]="{tab: processedButton.route}"
                   #insightsMenuTrigger="matMenuTrigger"></div>

              <div class="icon-container"
                   [ngClass]="{ 'bg-green-90': processedButton.route === activeRoute }">
                <mat-icon [svgIcon]="processedButton.route === activeRoute ? processedButton.svgName + '_filled' :
                                     processedButton.svgName"></mat-icon>
              </div>
              <span class="text-center">{{
                  ('PAGE.' + processedButton.route.toUpperCase()) | translate
                }}</span>
            </div>
          }
        }
      }

    </div>

    <div class="grow"></div>

    <div id="toolbar-button-container">
      <!-- Notification setting -->
      <div class="icon-button-3">
        <button id="email-notification-settings-button"
                mat-icon-button
                class="mb-1 z-[1]"
                [disabled]="value.emailSettingsLoading"
                (click)="openNotificationSettings()">
          <mat-icon class="text-neutral-40" svgIcon="notification"/>
        </button>

        @if (value.emailSettingsLoading) {
          <mat-spinner class="absolute top-0 left-0" [diameter]="36"></mat-spinner>
        }
      </div>

      <!-- Jira service desk -->
      <div class="icon-button-3"
           [matTooltip]="value.selectedAccount?.jiraDeskIntegrationActivated ? ('JIRA_ENABLED' | translate) : ('JIRA_DISABLED' | translate)"
           [matTooltipPosition]="'right'">
        <button mat-icon-button
                class="mb-1"
                [ngClass]="{'text-neutral-40': value.selectedAccount?.jiraDeskIntegrationActivated,
                            'text-neutral-90': !value.selectedAccount?.jiraDeskIntegrationActivated}"
                [disabled]="!value.selectedAccount?.jiraDeskIntegrationActivated"
                (click)="openJira()">
          <mat-icon svgIcon="support"></mat-icon>
        </button>
      </div>

      <!-- account menu button -->
      <div class="acc-menu-button"
           [ngClass]="{ 'border-[2px] border-solid border-green-40': accountSettingsMenuTrigger.menuOpen }"
           (click)="openAccountSettingsMenu()"
           (clickOutside)="closeAccountSettingsMenu()">
        <div [matMenuTriggerFor]="accountSettingsMenu"
             #accountSettingsMenuTrigger="matMenuTrigger"></div>
        <!-- The user picture form ID token -->
        @if (value?.user?.picture) {
          <img
              class="w-[32px] h-[32px] rounded-full"
              [src]="value?.user?.picture"
              alt="user_picture">
        }

        <!-- User icon placeholder -->
        @if (!value?.user?.picture) {
          <mat-icon svgIcon="account_circle"
                    class="w-[32px] h-[32px]"></mat-icon>
        }
      </div>

      <!-- navigation toggle placeholder -->
      <div class="h-10"></div>

    </div>

  </div>


  <!--                    MENUS                           -->


  <mat-menu #accountSettingsMenu="matMenu"
            xPosition="after"
            yPosition="below"
            class="accountSettingsMenuPanel">

    <div id="user-section"
         class="flex flex-col items-center justify-center">
      <div id="avatar-container"
           class="h-[64px] w-[64px] mt-4 mb-2">
        <!-- The user picture form ID token -->
        @if (value?.user?.picture) {
          <img
              class="w-full h-full rounded-full"
              [src]="value?.user?.picture"
              alt="user_picture">
        }

        <!-- User icon placeholder -->
        @if (!value?.user?.picture) {
          <mat-icon svgIcon="account_circle"
                    class="w-full h-full text-neutral-30"></mat-icon>
        }
      </div>

      <span class="mb-4 mx-4 break-all whitespace-pre-line">{{
          value?.userStatus ?
              isSharedUser(value?.userStatus) ? value?.user?.nickname : value?.user?.email :
              value?.selectedAccount?.accountName
        }}</span>

      <div id="logout-and-dev-section"
           class="w-full">
        <mat-divider class="mt-1 mb-1"></mat-divider>
        @if (!isProd && (isLoggedIn$ | ngrxPush)) {
          <button mat-menu-item
                  (click)="startGoogleAuthentication(value.selectedAccount?.id)">
            <mat-icon svgIcon="fingerprint"></mat-icon>
            Start Google authentication
          </button>
        }

        @if ((isLoggedIn$ | ngrxPush)) {
          <button mat-menu-item class="menuOption"
                  (click)="logout()"
                  appGtagEvent trackOn="click" action="logout"
                  category="User Management" [params]="{event_label: 'User logged out'}">
            <mat-icon svgIcon="logout"></mat-icon>
            {{ 'LOGIN.LOGOUT' | translate }}
          </button>
        }
        <mat-divider class="mt-1 mb-1"></mat-divider>
      </div>

      @if (value.accounts?.length > 1) {
        <div id="account-section"
             class="w-full">
          <span class="text-label-medium ml-4">{{ 'LOGIN.ACCOUNTS' | translate }}</span>
          <div id="account-container">
            @for (account of value.accounts; track account) {
              <button mat-menu-item
                      [ngClass]="{'menuOption': true, 'activeMenuOption': account.accountName === value.selectedAccount?.accountName}"
                      (click)="selectAccount(account, value.selectedAccount?.accountName)">
                <div class="flex w-full items-center">
                  <mat-icon svgIcon="groups_outlined"
                            class="w-6 h-6 text-neutral-30 mr-4"/>
                  <span class="break-all whitespace-pre-line">{{ account.accountName }}</span>
                  <span class="grow"></span>
                  @if (account.accountName === value.selectedAccount?.accountName) {
                    <mat-icon svgIcon="done"
                              class="checkIcon">
                    </mat-icon>
                  }
                </div>
              </button>
            }
          </div>
          <mat-divider class="mt-1 mb-1"></mat-divider>
        </div>
      }

      <div id="language-section" class="w-full">
        <span class="text-label-medium ml-4">{{ 'LOGIN.LANGUAGE' | translate }}</span>
        @for (language of languages; track language.code) {
          <button mat-menu-item
                  id="{{ 'select-ui-language-' + language.code }}"
                  [ngClass]="{'menuOption': true, 'activeMenuOption': language.code === translate.currentLang}"
                  (click)="setAndUpdateLanguage(language.code)"
                  appGtagEvent trackOn="click" action="language change"
                  category="User Management"
                  [params]="{ event_label: 'Changed language to ' + (language.code | languageNativeName) }">
            <div class="flex w-full">
              <div class="flag-container">
                <span>{{ language.countryCode | flagEmoji }}</span>
              </div>
              <span class="flex items-center">{{ language.code | languageNativeName }}</span>
              <span class="grow"></span>
              @if (language.code === translate.currentLang) {
                <mat-icon svgIcon="done"
                          class="checkIcon">
                </mat-icon>
              }
            </div>
          </button>
        }
        <mat-divider class="mt-1 mb-1"></mat-divider>
      </div>

      <div id="various-section" class="w-full">
        @if (hotkeysService.getHotkeysLength()) {
          <button mat-menu-item
                  (click)="hotkeysService.openHotkeysPopup()"
          >
            <mat-icon svgIcon="keyboard_outline"></mat-icon>
            <span>Keyboard shortcuts</span>
          </button>
        }
        <button mat-menu-item
                routerLink="/guide"
                appGtagEvent
                trackOn="click"
                action="Open LSC guide"
                category="Navigation">
          <mat-icon svgIcon="class_outline"></mat-icon>
          <span>LSC Guide</span>
        </button>
        <button mat-menu-item
                (click)="openFeedbackDialog()">
          <mat-icon svgIcon="sms_failed_outline"></mat-icon>
          <span>{{ 'PAGE.INFO_MENU.SEND_FEEDBACK' | translate }}</span>
        </button>
        <button mat-menu-item
                (click)="openConsentPopup()">
          <mat-icon svgIcon="cookie"></mat-icon>
          <span>{{ 'CONSENT.POPUP_TITLE' | translate }}</span>
        </button>

        @if (value.jasonerEnabled) {
          <button mat-menu-item
                  (click)="openJasoner($event)">
            <div class="flex items-center">
              <img src="assets/images/jasoner_logo.png"
                   alt="Jasoner"
                   class="p-[1px] mr-3">
              <span class="w-full">{{ 'OPEN_JASONER' | translate }}</span>
              @if (jasonerLinkLoading()) {
                <mat-progress-spinner [diameter]="24" mode="indeterminate"/>
              }
            </div>
          </button>
        }

        @if (value.gxWrapped?.length && environment.activeFeatures.gxWrapped) {
          <button mat-menu-item
                  (click)="openGxWrapped(value.gxWrapped)">
            <mat-icon svgIcon="year_in_review"></mat-icon>
            <span>{{ 'GX_WRAPPED.YEAR_IN_REVIEW' | translate }}</span>
          </button>
        }
      </div>

    </div>
  </mat-menu>

  <mat-menu #insightsMenu="matMenu" xPosition="after" yPosition="below" [hasBackdrop]="false"
            class="mt-[4px] rounded-md">
    <ng-template matMenuContent let-tab="tab">
      <div (mouseenter)="openInsightsMenu()"
           (mouseleave)="closeInsightsMenu()">
        <button mat-menu-item
                (click)="navigate(tab)">
          <span>{{ ('PAGE.' + tab.toUpperCase() + '_MENU_ITEM') | translate }}</span>
        </button>
        <a mat-menu-item
           class="flex flex-row items-center"
           target="_blank"
           href="https://datastudio.google.com/u/0/"
           appGtagEvent
           trackOn="click"
           action="Open LIVD page"
           category="Navigation">
          <span class="w-full flex items-center">
            <span class="w-full">LIVD</span>
            <mat-icon svgIcon="open_in_new" class="mr-0 w-[22px] h-[22px]"></mat-icon>
          </span>
        </a>
      </div>
    </ng-template>
  </mat-menu>

</ng-container>
